import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const blobsModule = namespace('blobs');
let ExpandedContentDetail = class ExpandedContentDetail extends Vue {
    created() {
        this.fetchExpandedContentBlobs();
    }
    get title() {
        return this.expandedContentName + Vue.prototype.$titleSuffix;
    }
    get blob() {
        return this.expandedContentBlobs.find(({ chapterName }) => chapterName === this.expandedContentName);
    }
};
__decorate([
    blobsModule.State
], ExpandedContentDetail.prototype, "expandedContentBlobs", void 0);
__decorate([
    blobsModule.Action
], ExpandedContentDetail.prototype, "fetchExpandedContentBlobs", void 0);
__decorate([
    Prop(String)
], ExpandedContentDetail.prototype, "expandedContentName", void 0);
ExpandedContentDetail = __decorate([
    Component({
        components: {
            VueMarkdown,
            BackButton,
            Loading
        }
    })
], ExpandedContentDetail);
export default ExpandedContentDetail;
